<template>
  <v-app id="agentCom">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="4">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
      </v-row>
     
      <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small :disabled="submitted" @click="ovrz">Create excel sheet</v-btn>
          </v-col> 
      </v-row>

    </v-container>
     <showProgress ref="showProgress"></showProgress>
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import showProgress from "@/components/showProgress.vue";
 export default {
  components: {
    navBar,
    showProgress
  },
  data() {
    return {
      bedrCodesSelected: [],
      bedrCodes: [],
      selectCodesSelected: '',
      selectCodes: [],
      submitted: false,
      param: {}
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/task/fin/ovrz/getPublParam.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getPublParam"
        },
        getPublParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getPublParam; 
           res.data.getPublParam.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
        }
      });

  },
  methods: {
     ovrz() {
      this.results = true;
      this.submitted = true;
      this.$refs.showProgress.open();
      this.$axios
        .post("ares/json/ares/task/fin/ovrz/excelExportPubl.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelExportPubl"
          },
          excelExportPubl: {
            bedr_codes: this.bedrCodesSelected
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {

            this.items = res.data.excelExportPubl;
            this.$refs.showProgress.close();
            this.submitted = false;
            window.open(this.items.filename,'_blank');

          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
